import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class PaymentService {

    AddPayment = async (payment) => {
        return Auth.post('/payments/create-order', payment)
    };

    VerifyPayment = async (payment) => {
        return Auth.post('/payments/verify', payment)
    };

    AddAddonPayment = async (payment) => {
        return Auth.post('/addon-packs/purchase', payment)
    };

    // GetById(paymentId) {
    //     return Auth.get(`/payments/${paymentId}`)
    // }

}

export default PaymentService

